import type { ContractCategory } from '../services/api/contractService';

/** Contract categories, in display order. Values match the backend's ContractCategory enum. */
export const CONTRACT_CATEGORIES: { value: ContractCategory; label: string }[] = [
  { value: 'beauty', label: 'Beauty' },
  { value: 'travel_retail', label: 'Travel Retail' },
  { value: 'toys', label: 'Toys' },
  { value: 'food', label: 'Food' },
  { value: 'sports', label: 'Sports' }
];

export const categoryLabel = (value?: string | null): string =>
  CONTRACT_CATEGORIES.find((c) => c.value === value)?.label ?? '';
